import React from "react";
import { observer } from "mobx-react-lite";
import { useFilePickerState } from "../../states";
import styled from "styled-components";

const InputEl = styled.input`
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  cursor: pointer;
`;

export const FilePickerInput: React.FC = observer(() => {
  const state = useFilePickerState();
  const { isLoading, onInputChange, onDrop, onClick } = state;
  const onDragEnter = (event: any) => {
    event.preventDefault();
    state.isDragActive = true;
  };

  const onDragOver = (event: any) => {
    event.preventDefault();
    state.isDragActive = true;
  };

  const onDragLeave = (event: any) => {
    event.preventDefault();
    state.isDragActive = false;
  };

  const _onDrop = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    state.isDragActive = false;
    onDrop(Array.from(event?.dataTransfer?.files!));
  };
  return (
    <InputEl
      onClick={onClick}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={_onDrop}
      id="asp-file-picker-input"
      disabled={isLoading}
      onChange={onInputChange}
      type="file"
      accept="image/png|image/jpg|image/jpeg|.pdf"
      multiple={false}
      ref={state.inputRef}
    />
  );
});
